import { Sun } from '@snack-uikit/loaders';
import { Typography } from '@snack-uikit/typography';
import { Dispatch, SetStateAction } from 'react';

import { useQuery } from '@/hooks/query';
import { selfApiGlossaryInstance } from '@/services/http';
import { SelfApiGlossaryRes } from '@/types/network';
import { getUrlAnchor, removeAnchorFromUrlString } from '@/utils/navigation';
import { skipHashTag } from '@/utils/strings';

import { GlossaryTooltipProps } from '../types';

export function ToolTipContent({
  pathToGlossary,
  tooltipContent,
  setTooltipContent,
}: GlossaryTooltipProps & {
  tooltipContent: SelfApiGlossaryRes | null;
  setTooltipContent: Dispatch<SetStateAction<SelfApiGlossaryRes | null>>;
}) {
  const { isLoading } = useQuery<SelfApiGlossaryRes | null>({
    query: `${removeAnchorFromUrlString(pathToGlossary)}?anchor=${skipHashTag(getUrlAnchor(pathToGlossary))}`,
    skipReq: Boolean(tooltipContent),
    processingResponse: setTooltipContent,
    customInstance: selfApiGlossaryInstance,
  });

  // TODO migrate to Spinner component
  if (!tooltipContent || isLoading) return <Sun size='s' />;

  return <Typography.LightBodyM> {tooltipContent.data}</Typography.LightBodyM>;
}
